<template>
  <footer class="footer">
    <span>
      <router-link to="/about" class="waves-effect">
        About Us
      </router-link>
      <router-link to="/terms-and-condition" class="waves-effect">
        T&amp;C
      </router-link>
    </span>
    <span class="text-center">
      © {{ currentYear }}
      <a href="https://www.istrategytech.com" target="_blank"
        >Infostrategy Technology</a
      >
    </span>
  </footer>
</template>

<script>
export default {
  name: 'FooterInfo',
  data() {
    return {
      currentYear: ''
    }
  },
  created() {
    this.getYear()
  },
  methods: {
    getYear() {
      var n = new Date().getFullYear()
      this.currentYear = n
    }
  }
}
</script>

<style></style>
